export default __webpack_public_path__ + "static/media/christian.03d47b1a.jpg";